"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DesktopMenuItem = _interopRequireWildcard(require("./MenuItem/DesktopMenuItem"));

var _MobileMenuItem = _interopRequireDefault(require("./MenuItem/MobileMenuItem"));

var _IconContainer = _interopRequireDefault(require("../IconContainer"));

var _ArrowDownIcon = _interopRequireDefault(require("../Icons/ArrowDownIcon"));

var _UserIcon = _interopRequireDefault(require("../Icons/UserIcon"));

var _CancelIcon = _interopRequireDefault(require("../Icons/CancelIcon"));

var _MenuIcon = _interopRequireDefault(require("../Icons/MenuIcon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenCloseArrow = (0, _styledComponents.default)(_ArrowDownIcon.default).withConfig({
  displayName: "OpenCloseArrow",
  componentId: "sc-1i0uzat-0"
})(["transition:0.3s;transform:", ";"], function (_ref) {
  var open = _ref.open;
  return open ? "rotate(180deg)" : "";
});

var AccountMenuItem = function AccountMenuItem(_ref2) {
  var children = _ref2.children,
      onClick = _ref2.onClick,
      open = _ref2.open;
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });
  return _react.default.createElement(_react.default.Fragment, null, isDesktop ? _react.default.createElement(_DesktopMenuItem.default, {
    current: open,
    onClick: onClick,
    icon: _UserIcon.default
  }, "My account", _react.default.createElement(_DesktopMenuItem.Spacer, null), _react.default.createElement(_IconContainer.default, {
    hasText: true
  }, _react.default.createElement(OpenCloseArrow, {
    open: open
  }))) : _react.default.createElement(_MobileMenuItem.default, {
    onClick: onClick,
    icon: open ? _CancelIcon.default : _MenuIcon.default
  }, open ? 'Close' : 'Menu'), children);
};

var _default = AccountMenuItem;
exports.default = _default;